import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useParams } from 'react-router-dom';
import { ROUTE_BASE_URL, baseUrl } from '../../../api/common';

const AdminUserPermission = () => {

    const { slug } = useParams();

    const [userDetails,setUserDetails]=useState({});
    const [userPermissions,setUserPermissions]=useState([]);
    const fetchUserPermission = async ()=>{
        try {
            const response = await axios.post(
              `${baseUrl}/api/role_details`,
              {id:slug},   
              {
                headers: {
                  'Content-Type': 'application/json',
                  Authorization: localStorage.getItem('access_token'),
                },
              }
            );        
            if (response.data.status) {
              setUserDetails(response.data.data[0]);  
              if(response.data.other_data.length>0){ 
                setUserPermissions(response.data.other_data);    
              }                
            } else {
              console.error('Error: Failed to fetch user data');
            }
          } catch (error) {
            console.error('Error fetching users data:', error);
          }
    }

    useEffect(()=>{
      fetchUserPermission();
    },[]);

    return (
        <>
            <div className="container-fluid">
                <div className="block-header">
                    <div className="row clearfix">
                        <div className="col-md-6 col-sm-12">
                            <h1>Admin Users Role</h1>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to={`${ROUTE_BASE_URL}/`}>AMASI</Link></li>
                                    <li className="breadcrumb-item"><Link to={`${ROUTE_BASE_URL}/admin-user-role`}>Admin Users Role</Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">Role Permission</li>
                                </ol>
                            </nav>
                        </div>
                        <div className="col-md-6 col-sm-12 text-right hidden-xs">
                        </div>
                    </div>
                </div>
                <div className="col-lg-12">
                    <div className="card role_table">
                    <div className="header">
                        {userDetails&&<h2>{userDetails.role_name}</h2>}
                        </div>
                        <div className="table-responsive">
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>S.NO</th>
                                        <th>Modules</th>
                                        <th className='text-center'>View</th>
                                        <th className='text-center'>Create</th>
                                        <th className='text-center'>Update</th>
                                        <th className='text-center'>Delete</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {
                                    userPermissions && userPermissions.map((item, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{item.module_name}</td>
                                        <td className="text-center">
                                        <span className={`${item.permission_view === 1 ? "text-success" : "text-danger"}`}>
                                            <i className={`${item.permission_view === 1 ? "fa fa-check" : "fa fa-times"}`}></i>
                                        </span>
                                        </td>
                                        <td className="text-center">
                                        <span className={`${item.permission_create === 1 ? "text-success" : "text-danger"}`}>
                                            <i className={`${item.permission_create === 1 ? "fa fa-check" : "fa fa-times"}`}></i>
                                        </span>
                                        </td>
                                        <td className="text-center">
                                        <span className={`${item.permission_update === 1 ? "text-success" : "text-danger"}`}>
                                            <i className={`${item.permission_update === 1 ? "fa fa-check" : "fa fa-times"}`}></i>
                                        </span>
                                        </td>
                                        <td className="text-center">
                                        <span className={`${item.permission_delete === 1 ? "text-success" : "text-danger"}`}>
                                            <i className={`${item.permission_delete === 1 ? "fa fa-check" : "fa fa-times"}`}></i>
                                        </span>
                                        </td>
                                    </tr>
                                    ))
                                }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div >
        </>
    );

}
export default AdminUserPermission
